module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-10 col-sm-offset-1"
  }, [(!_vm.loading) ? _c('form', {
    staticClass: "col-xs-12 col-sm-6",
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.logReport($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "compuslory",
    attrs: {
      "for": "channel"
    }
  }, [_vm._v("Channel Name")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportForm.channel),
      expression: "reportForm.channel"
    }],
    ref: "channel",
    staticClass: "form-control",
    attrs: {
      "id": "channel"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.reportForm.channel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("--Select channel--")]), _vm._v(" "), _vm._l((_vm.channels), function(eachChannel, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": eachChannel._id
      }
    }, [_vm._v(_vm._s(eachChannel.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "compuslory"
  }, [_vm._v("Cost")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.reportForm.spend),
      expression: "reportForm.spend",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reportForm.spend)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportForm.spend = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "compuslory"
  }, [_vm._v("Impressions")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.reportForm.impressions),
      expression: "reportForm.impressions",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.reportForm.impressions)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportForm.impressions = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "compuslory"
  }, [_vm._v("Reach")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.reportForm.reach),
      expression: "reportForm.reach",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.reportForm.reach)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportForm.reach = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "compuslory"
  }, [_vm._v("Action")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.reportForm.action),
      expression: "reportForm.action",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.reportForm.action)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportForm.action = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "compuslory"
  }, [_vm._v("Date/Week (YYYY-MM-DD)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportForm.week),
      expression: "reportForm.week"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reportForm.week)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportForm.week = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportForm.description),
      expression: "reportForm.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reportForm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.reportForm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.submitting) ? _c('div', {
    staticClass: "form-loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader.gif"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.submitting) ? _c('p', {
    class: _vm.message.style
  }, [_vm._v(_vm._s(_vm.message.text))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [(!_vm.submitting) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loader.gif"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.reports.length && !_vm.loading) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('br'), _c('br'), _c('h3', [_vm._v("All Logged Reports")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.reports), function(report, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.channel.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.spend))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.impressions))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.reach))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.action))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(report.week))])])
  }))])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.reports.length) ? _c('div', {
    staticClass: "col-xs-12 error"
  }, [_vm._v("Reports could not be retrieved")]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Cost & Acquisition\n      "), _c('small', [_vm._v("Log Weekly Report")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Cost & Acquisition")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Log Weekly Report")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Channel")]), _vm._v(" "), _c('th', [_vm._v("Cost")]), _vm._v(" "), _c('th', [_vm._v("Impressions")]), _vm._v(" "), _c('th', [_vm._v("Reach")]), _vm._v(" "), _c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Date/Week")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3e4be8a4","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cost-acquisition/Report.vue
// module id = VxKD
// module chunks = 1